import { z } from 'zod';
import { AgencySchema } from '../auth/RegisterFormData';
import { isValidSelectorString } from '@/utils/validations/selector.validation';

const optionalPhoneNumber = z
  .union([
    z
      .string()
      .regex(
        /^\+?[0-9]+$/,
        'Le numéro de téléphone ne doit contenir que des chiffres ou un + au début',
      )
      .min(5, 'Le numéro de téléphone doit contenir au moins 5 caractères'),
    z.literal(''),
  ])
  .optional();

const optionalPassword = z
  .union([
    z.string().min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
    z.literal(''),
  ])
  .optional();

/** Agency fields are optional on profile edit; format is validated when provided. */
const ProfileAgencySchema = AgencySchema.partial().extend({
  name: z.string().min(1, 'Le nom est requis').optional(),
  siren: z
    .union([
      z.string().min(9, 'Le numéro SIREN doit contenir au moins 9 caractères'),
      z.literal(''),
    ])
    .optional(),
});

export const DistributorProfileSchema = z.object({
  firstName: z
    .string({ message: 'Le prénom est requis' })
    .min(1, { message: 'Le prénom est requis' }),
  lastName: z
    .string({ message: 'Le nom est requis' })
    .min(1, { message: 'Le nom est requis' }),
  email: z
    .string({
      required_error: "L'email est requis",
      invalid_type_error: 'Email incorrect',
    })
    .email({ message: 'Email non valide' }),
  phoneNumber: optionalPhoneNumber,
  password: optionalPassword,
  network: z
    .object({
      label: z.string().optional(),
      value: z.string().optional(),
    })
    .optional(),
  agency: ProfileAgencySchema,
  mainLanguage: isValidSelectorString('La langue principale est requise'),
});

export type DistributorProfileFormData = z.infer<
  typeof DistributorProfileSchema
>;
